<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading">

  <mat-card appearance="outlined" *ngIf="!!customer">
    <mat-card-title>Contact</mat-card-title>
    <div class="split-wrapper">
      <mat-card appearance="outlined" class="split">
        <div>
          <span *ngIf="customer.name.title">{{customer.name.title}}</span>
          <span *ngIf="customer.name.firstName">{{customer.name.firstName}}</span>
          <span *ngIf="customer.name.lastName">{{customer.name.lastName}}</span>
        </div>
        <div *ngIf="customer.address.street">{{customer.address.street}}</div>
        <div *ngIf="customer.address.streetAdditional">{{customer.address.streetAdditional}}</div>
        <div>
          <span *ngIf="customer.address.zip">{{customer.address.countryCode}}-{{customer.address.zip}}</span>
          <span *ngIf="customer.address.city"> {{customer.address.city}}</span>
        </div>
      </mat-card>
      <mat-card appearance="outlined" class="split">
        <div *ngIf="customer.contact.tel">{{customer.contact.tel}}</div>
        <div *ngIf="customer.contact.fax">{{customer.contact.fax}}</div>
        <div *ngIf="customer.contact.url"><a href="{{customer.contact.url|ensureLinkPrefix}}" target="_blank">{{customer.contact.url}}</a>
        </div>
        <div *ngIf="customer.contact.mail"><a href="mailto:{{customer.contact.mail}}">{{customer.contact.mail}}</a></div>
      </mat-card>
    </div>
  </mat-card>

  <div *ifPrivilege="{name: 'read', value: 'screens'}" class="screen-table-container">
    <div class="spacer"></div>
    <button (click)="generateCustomJsons()" *ngIf="cfList && cfList.length > 0" class="ibexfusion-raised-button cf-button" mat-button>
      Generate JSON's by cf for all screens
    </button>
    <app-screen-list [customerId]="customer._id"></app-screen-list>
  </div>

  <ng-container *ifPrivilege="{name: 'read', value: 'packages'}">
    <div class="spacer"></div>
    <data-table
      (detail)="onDetailPackage($event)"
      [columns]="columnsPackage"
      [dataProviderParams]="paramsPackage"
      [dataProvider]="packageService"
      [hideSearch]="true"
      [title]="'Packages'">
    </data-table>
  </ng-container>

  <div class="spacer"></div>

  <ng-container *ifPrivilege="{name: 'read', value: 'imports'}">
    <div class="spacer"></div>
    <mat-card appearance="outlined" *ngIf="!!customerImports">
      <mat-card-title>Imports by Customer</mat-card-title>
      <ng-container *ngFor="let entry of customerImports">
        <mat-expansion-panel *ngIf="entry">
          <mat-expansion-panel-header>
            <mat-panel-title> {{entry.name}}, Type: {{entry.importType}}</mat-panel-title>
            <mat-panel-description></mat-panel-description>
          </mat-expansion-panel-header>

          <ng-container *ngIf="entry.properties">
            <mat-list-item *ngIf="entry.properties['Main App Item Id']">Import App ID
              : {{entry.properties['Main App Item Id']}}</mat-list-item>
            <mat-list-item *ngIf="entry.properties['Main Widget Item Id']">Import Widget ID
              : {{entry.properties['Main Widget Item Id']}}</mat-list-item>
            <mat-list-item *ngIf="entry.properties['MenuItem id']">Import Menu Item (Menu)
              : {{entry.properties['MenuItem id']}}</mat-list-item>
            <mat-list-item *ngIf="entry.properties['MenuEntry id']">Import Menu Entry (Widget preview)
              : {{entry.properties['MenuEntry id']}}</mat-list-item>
            <mat-list-item *ngIf="entry.properties['Menu Item Id']">Import Menu Item (App)
              : {{entry.properties['Menu Item Id']}}</mat-list-item>
            <mat-list-item *ngIf="entry.properties['Menu Entry Id']">Import Menu Entry (Widget preview)
              : {{entry.properties['Menu Entry Id']}}</mat-list-item>
          </ng-container>

          <ng-container *ngFor="let item of entry.assignable">
            <mat-list-item>Assignable Item Title: {{item.title}}</mat-list-item>
            <mat-list-item>Assignable Item Id: {{item.menuItemId}}</mat-list-item>
          </ng-container>

          <mat-list-item>
            <button mat-button>
              <a [routerLink]=entry.url class="default">Go to Importer</a>
            </button>
          </mat-list-item>

          <mat-list-item *ngIf="entry.fetchLog">
            <button (click)="fetchLog(entry.id)" mat-button>Fetch From Log Data</button>
          </mat-list-item>

        </mat-expansion-panel>
      </ng-container>
    </mat-card>
  </ng-container>

  <div class="spacer"></div>
  <mat-card appearance="outlined">
    <mat-card-title>Legacy Compostitions</mat-card-title>
    <mat-list-item>{{customer.compositionNames}}</mat-list-item>
  </mat-card>

</page-content>
